import IconContact from 'images/icons/contact-white.svg';
import { useYieldCallback } from '@zillow/yield-callback';
import FloatingActionButton from '../FloatingActionButton';
import { contactFABStyles } from './ContactButtonV2.styles';

interface FloatingActionContactButtonProps {
  contactButtonClass?: string;
  onContactFabClick?: () => void;
}

const FloatingActionContactButton: React.FC<FloatingActionContactButtonProps> = ({
  contactButtonClass,
  onContactFabClick,
}) => {
  const onClickCallback = useYieldCallback(() => {
    onContactFabClick?.();
  });

  const fabClassName = contactFABStyles({
    contactButtonClass: contactButtonClass as 'compact' | undefined,
  });

  return (
    <FloatingActionButton className={fabClassName} onClick={onClickCallback} aria-label="Contact">
      <img src={IconContact} width="22px" height="20px" alt="" loading="lazy" />
    </FloatingActionButton>
  );
};

export default FloatingActionContactButton;
